import sha256 from 'crypto-js/sha256';
import tokenProvider from '../provider';

export default function hashPassword(pwd: string): string {
    return sha256(tokenProvider.userInfo.uuid + pwd)
        .toString()
        .toLowerCase();
}
